// El interruptor de WhatsApp, dentro de Configuración → Notificaciones
// (ADR-2026-11-02-interruptor-de-whatsapp). Guarda al toque, como los demás interruptores de
// Configuración. Si no se puede leer la preferencia, no se muestra.

import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Interruptor } from './Interruptor';
import { cambiarRecibeWhatsApp, leerRecibeWhatsApp } from '../../lib/preferenciaWhatsApp';
import { useAperturaAnimada } from '../../hooks/useAperturaAnimada';

interface Props {
  setError: (error: string | null) => void;
  setSuccess: (success: string | null) => void;
}

export const PreferenciaWhatsApp: React.FC<Props> = ({ setError, setSuccess }) => {
  const [recibe, setRecibe] = useState<boolean | null>(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    let vivo = true;
    void leerRecibeWhatsApp().then((v) => {
      if (vivo) setRecibe(v);
    });
    return () => {
      vivo = false;
    };
  }, []);

  // Aparece cuando llega la preferencia: entra con la transición de la casa.
  const { montado, visible } = useAperturaAnimada(recibe !== null, 150);
  if (!montado || recibe === null) return null;

  const cambiar = async (siguiente: boolean) => {
    setGuardando(true);
    setError(null);
    setSuccess(null);
    setRecibe(siguiente);
    const ok = await cambiarRecibeWhatsApp(siguiente);
    setGuardando(false);
    if (ok) {
      setSuccess(siguiente ? 'Listo. Te vamos a volver a escribir por WhatsApp.' : 'Listo. No te vamos a escribir más por WhatsApp.');
    } else {
      setRecibe(!siguiente);
      setError('No se pudo guardar. Probá de nuevo.');
    }
  };

  return (
    <div
      className={`mt-6 border-t border-neutral-200 pt-6 transition-[opacity,transform,filter] ease-out ${
        visible
          ? 'duration-300 opacity-100 motion-safe:translate-y-0 motion-safe:blur-0'
          : 'duration-150 opacity-0 motion-safe:translate-y-3 motion-safe:blur-[4px]'
      }`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <MessageCircle className="w-5 h-5 text-brand-primary shrink-0 mt-0.5" />
          <div>
            <div className="text-[14px] font-medium text-brand-black/90">Mensajes por WhatsApp</div>
            <p className="text-[13px] text-brand-black/50 mt-0.5">
              Ideas y avisos sobre tu cuenta. Podés apagarlos cuando quieras.
            </p>
          </div>
        </div>
        <Interruptor
          activo={recibe}
          onChange={(v) => void cambiar(v)}
          disabled={guardando}
          etiqueta="Recibir mensajes de Atlas por WhatsApp"
        />
      </div>
    </div>
  );
};

export default PreferenciaWhatsApp;
